import {formattedDate} from '$app/core/utils/dataTableRenderers';


const defaultUnfriendlyText = event => `${event.eventType} : ${event.eventName}`
const bookingEditFriendlyText = (event) => {
  const txt = [];
  if(event.changes.masterStatusId) {
    switch(event.currentStatus) {
      case 'UNALLOCATED':
        txt.push('Booking was unallocated')
        break
      default: txt.push(`Status ${event.currentStatus}`)
    }
  }
  if(event.changes.collectionDateTimeLocal) txt.push(`Collection date changed from ${formattedDate(event.oldState.collectionDateTimeLocal)} to ${formattedDate(event.currentState.collectionDateTimeLocal)}`)
  if(event.changes.deliveryDateTimeLocal) txt.push(`Delivery date changed from ${formattedDate(event.oldState.deliveryDateTimeLocal)} to ${formattedDate(event.currentState.deliveryDateTimeLocal)}`)
  if(event.changes.collectionAddressId)  txt.push(`Collection addressed changed`)
  if(event.changes.deliveryAddressId) txt.push(`Delivery address changed`)
  if(event.changes.garageTotalPrice) txt.push(`Work operations changed`)
  if(event.changes.pence) txt.push(`Total price has been affected`)
  if(event.changes.caseManagerId) txt.push(`Case manager ${event.changes.caseManagerId} was assigned to the booking`)
  if(event.changes.garageStatus) {
    if(event.changes.garageStatus === 'CUSTOMER_REVIEW') {
      txt.push(`Proposed quote sent to the customer for approval`);
    }
  }

  return txt.join(', ');
}

const bookingChangeToFriendlyText = event => {
  switch(event.currentStatus) {
    case 'DRAFT': {
      if (event.currentState.caseManagerId) return `Case manager(${event.currentState.caseManagerId}) edited draft booking`
      return 'Customer edited draft booking'
    }
    case 'UNALLOCATED': switch(event.oldStatus) {
      case 'DRAFT': {
        if (event.currentState.caseManagerId) return `Case manager(${event.currentState.caseManagerId}) finished booking`
        return 'Customer finished booking'
      }
      case 'PENDING': return 'Garage invitation expired'
      default: return bookingEditFriendlyText(event)
    }
    case 'PENDING': switch(event.oldStatus) {
      case 'UNALLOCATED':
      case 'GARAGE_DECLINED': return 'Booking is waiting garage response'
      case 'PENDING': return bookingEditFriendlyText(event)
      default: return bookingEditFriendlyText(event)
    }
    case 'GARAGE_DECLINED': return 'Garage refused job invitation'
    case 'ALLOCATED': switch(event.oldStatus) {
      case 'PENDING': return 'Garage job invitation was accepted'
      default: return bookingEditFriendlyText(event)
    }
    case 'AWAITING_PICKUP': switch(event.oldStatus) {
      case 'ALLOCATED': return 'Driver has been assigned to collection tookan task'
      case 'AWAITING_PICKUP': return 'Driver has been assigned to delivery tookan task'
      case 'BEING_COLLECTED': return 'Driver failed to collect vehicle from the customer'
      case 'TRANSPORT_TO_GARAGE': return 'Driver failed to deliver vehicle to garage'
      default: return bookingEditFriendlyText(event)
    }
    case 'BEING_COLLECTED': switch(event.oldStatus) {
      case 'AWAITING_PICKUP': return 'Driver started journey to collect vehicle from the customer'
      default: return bookingEditFriendlyText(event)
    }
    case 'TRANSPORT_TO_GARAGE': switch(event.oldStatus) {
      case 'BEING_COLLECTED': return 'Driver successfully collected the vehicle from the customer and is on his way to the garage'
      default: return bookingEditFriendlyText(event)
    }
    case 'AT_GARAGE': switch(event.oldStatus) {
      case 'TRANSPORT_TO_GARAGE': return 'Driver delivered vehicle to garage'
      default: return bookingEditFriendlyText(event)
    }
    case 'WORK_COMPLETE': switch(event.oldStatus) {
      case 'AT_GARAGE': return 'Work was marked as completed'
      case 'WORK_COMPLETE': return bookingEditFriendlyText(event)
      default: return bookingEditFriendlyText(event)
    }
    case 'PAID': switch(event.oldStatus) {
      case 'WORK_COMPLETE': return 'Payment was taken'
      default: return bookingEditFriendlyText(event)
    }
    case 'BEING_RETURNED': switch(event.oldSatus) {
      case 'PAID': 'Driver is on journey to collect vehicle from garage and delivery to customer'
      default: return bookingEditFriendlyText(event)
    }
    case 'CLOSED': switch(event.oldSatus) {
      case 'BEING_RETURNED': 'Vehicle was delivery back to the customer'
      default: return bookingEditFriendlyText(event)
    }
    default: return defaultUnfriendlyText(event)
  }
}

const tookanChangeToFriendlyText = (event) => {
  switch(event.eventName) {
    case 'JOB_ASSIGNED': return 'Tookan task assigned to driver'
    default: return defaultUnfriendlyText(event)
  }
}

const customerNotificationToFriendyText = event => {
  switch(event.eventName) {
    case 'BOOKING_CREATED_NOTIFICATION': return 'Booking confirm notification sent to customer'
    case 'BOOKING_NOTIFICATION_DELAYED': return 'Booking delayed notification sent to customer'
    case 'BOOKING_UPDATED_NOTIFICATION': return 'Booking updated notification sent to customer'
    case 'COLLECTION_REMINDER_SENT': return 'Booking reminder notification sent to customer'
    case 'BOOKING_CANCELLED_NOTIFICATION': return 'Booking cancelled notification sent to customer'
    default: return defaultUnfriendlyText(event)
  }
}

const jobInviteSentFriendlyText = event => {
  switch(event.eventName) {
    case 'AUTOMATED': switch(event.currentStatus) {
      case '"SENT"': return 'Sent automatic job invitation'
      case '"NOT_SENT"': return 'Not sent automatic job invitation'
      default: return defaultUnfriendlyText(event)
    }
    case 'MANUAL':
      let message = 'Sent a job invitation';
      return event.author ? `${event.author} sent a job invitation` : message;
    default: return defaultUnfriendlyText(event)
  }
}

const jobInviteScheduledFriendlyText = event => {
  switch(event.eventName) {
    case 'AUTOMATED': switch(event.currentStatus) {
      case '"SCHEDULED"': return 'Scheduled automatic job invitation'
      default: defaultUnfriendlyText(event)
    }
    default: return defaultUnfriendlyText(event)
  }
}

const notificationToFriendlyText = event => {
  switch(event.eventName) {
    case 'CUSTOMER_NEXT_BOOKING_OFFER': switch(event.currentStatus) {
      case 'CLOSED': return 'Next booking offer was sent'
      case 'SENT': return 'Next booking offer email and a trustpilot review request invitation was sent'
      case 'NOT SENT': return 'Next booking offer and trustpilot review request invitation WAS NOT sent'
      default: return defaultUnfriendlyText(event)
    }
    default: return defaultUnfriendlyText(event)
  }
}

const trustpilotInvitationToFriendlyText = event => {
  switch(event.eventName) {
    case 'TRUSTPILOT_INVITATION_SENT': return 'Invitation for trustpilot review requested'
    default: return defaultUnfriendlyText(event)
  }
}

const xeroInvoiceToFriendlyText = event => {
  switch(event.eventName) {
    case 'INVOICE_CREATED': return 'Xero invoice was created'
    default: return defaultUnfriendlyText(event)
  }
}

const workOperationCreatedFriendlyText = event => {
  switch(event.eventName) {
    case 'MANUAL':
      let message = 'Added a work operation';
      return event.author ? `${event.author} added a work operation` : message;
    default: return defaultUnfriendlyText(event)
  }
}

const workOperationDeletedFriendlyText = event => {
  switch(event.eventName) {
    case 'MANUAL':
      let message = 'Deleted a work operation';
      return event.author ? `${event.author} deleted a work operation` : message;
    default: return defaultUnfriendlyText(event)
  }
}

export const formatFriendlyText = event => {
  switch(event.eventType) {
    case 'BOOKING_STATE_CHANGE': return bookingChangeToFriendlyText(event)
    case 'TOOKAN_CHANGE': return tookanChangeToFriendlyText(event)
    case 'JOB_INVITE_SENT': return jobInviteSentFriendlyText(event)
    case 'WORK_OPERATION_CREATED': return workOperationCreatedFriendlyText(event)
    case 'WORK_OPERATION_DELETED': return workOperationDeletedFriendlyText(event)
    case 'JOB_INVITE_SCHEDULED': return jobInviteScheduledFriendlyText(event)
    case 'CUSTOMER_NOTIFICATIONS': return customerNotificationToFriendyText(event)
    case 'NOTIFICATION': return notificationToFriendlyText(event)
    case 'TRUSTPILOT_INVITATION': return trustpilotInvitationToFriendlyText(event)
    case 'XERO_INVOICE': return xeroInvoiceToFriendlyText(event)
    default: return defaultUnfriendlyText(event)
  }
}
